import React, { useState } from 'react';
import { FormInputSelect } from 'components/form';
import { useMutation } from '@apollo/client';
import { opportunitiesListApi } from 'modules/vendorOpportunity/list/api';
import { displayStatusOptions } from 'modules/vendorOpportunity/list/constants';
import { SelectOption } from 'global';
import { Box } from '@mui/material';
import { useNotifications } from 'modules/notification';

interface Props {
  voId: string;
  displayStatus?: number;
}

export const DisplayStatusCell = ({ voId, displayStatus }: Props) => {
  const { showNotification } = useNotifications();

  const [updateDisplayStatus] = useMutation(opportunitiesListApi.updateRowDisplayStatus, {
    context: { authRequired: true },
  });

  const [value, setValue] = useState(displayStatus);

  const handleUpdateDisplayStatus = async (value: number) => {
    try {
      const result = await updateDisplayStatus({
        variables: {
          fieldsObj: {
            displayStatus: value,
          },
          VOId: voId,
        },
      });
      if (result?.data?.updateVendorOpportunity) {
        setValue(value);
        showNotification('Changes saved!');
      }
    } catch (err) {
      showNotification('Error', { type: 'error' });
    }
  };

  const getMenuOptions = (): SelectOption<number>[] => {
    return displayStatusOptions
      .filter(option => !Array.isArray(option.value))
      .map(({ label, value }) => ({ label, value }));
  };

  return (
    <Box onClick={(e: React.MouseEvent) => e.stopPropagation()}>
      <FormInputSelect<number>
        size="small"
        variant="standard"
        value={value}
        onChange={async nextValue => handleUpdateDisplayStatus(nextValue)}
        options={getMenuOptions()}
      />
    </Box>
  );
};
